import { render, staticRenderFns } from "./ContactDuputyChips.vue?vue&type=template&id=de09caf0&"
import script from "./ContactDuputyChips.vue?vue&type=script&lang=js&"
export * from "./ContactDuputyChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports